import { entityKey, rosterKey } from './ids';
import {
  projectAuditorStatusFromSession,
  projectRolesFromSession,
  projectRoomAssignmentsFromSession,
  sessionRolesKey,
} from './projectSession';

export { sessionRolesKey };

export function getSessionById(state, id) {
  if (!id) return null;
  return state.entities.sessions[entityKey(id)] || null;
}

export function getAllSessions(state) {
  return Object.values(state.entities.sessions);
}

export function getCohortById(state, id) {
  if (!id) return null;
  return state.entities.cohorts[entityKey(id)] || null;
}

export function getAllCohorts(state) {
  return Object.values(state.entities.cohorts);
}

/** Groups cohort entities by schoolId (string keys) for Schools module views. */
export function buildSchoolCohortsMap(state) {
  const map = {};
  getAllCohorts(state).forEach(cohort => {
    const schoolId = String(cohort.schoolId || '');
    if (!schoolId) return;
    if (!map[schoolId]) map[schoolId] = [];
    map[schoolId].push(cohort);
  });
  return map;
}

export function getStudentsForSchoolBranch(state, schoolId, branchId) {
  const key = rosterKey(schoolId, branchId);
  return state.rosters[key] || [];
}

export function rosterHasSchoolBranch(state, schoolId, branchId) {
  const key = rosterKey(schoolId, branchId);
  return state.rosters[key] !== undefined;
}

export function getAllRosterStudents(state) {
  return Object.values(state.rosters).flat();
}

export function getCohortSessions(state, cohortId) {
  const key = entityKey(cohortId);
  if (!key) return [];
  return Object.values(state.entities.sessions).filter(s => entityKey(s.cohortId) === key);
}

export function getSessionRoles(state, sessionId) {
  const session = getSessionById(state, sessionId);
  return projectRolesFromSession(session);
}

export function getSessionRoomAssignments(state, sessionId) {
  const session = getSessionById(state, sessionId);
  return projectRoomAssignmentsFromSession(session);
}

export function getAuditorSessionStatus(state, sessionId) {
  const session = getSessionById(state, sessionId);
  return projectAuditorStatusFromSession(session);
}

export function getSessionRolesFromMap(map, sessionId, cohortId = null) {
  const primary = sessionRolesKey(sessionId, cohortId);
  if (map[primary]) return map[primary];
  if (cohortId) return map[sessionRolesKey(sessionId)] || {};
  return {};
}

export function buildSessionRolesMap(state) {
  const map = {};
  getAllSessions(state).forEach(session => {
    if (session.groupId && session.groupCohortIds?.length) {
      session.groupCohortIds.forEach(cohortId => {
        const roles = projectRolesFromSession(session, cohortId);
        if (roles) map[sessionRolesKey(session.id, cohortId)] = roles;
      });
      return;
    }
    const roles = projectRolesFromSession(session);
    if (roles) map[entityKey(session.id)] = roles;
  });
  return map;
}

export function buildSessionRoomAssignmentsMap(state) {
  const map = {};
  getAllSessions(state).forEach(session => {
    const rooms = projectRoomAssignmentsFromSession(session);
    if (rooms) map[entityKey(session.id)] = rooms;
  });
  return map;
}

export function buildAuditorSessionStatusesMap(state) {
  const map = {};
  getAllSessions(state).forEach(session => {
    const status = projectAuditorStatusFromSession(session);
    if (status) map[entityKey(session.id)] = status;
  });
  return map;
}